import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';

const MinusCircleSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  // eslint-disable-next-line max-len
  d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7 11v2h10v-2H7z",
  className: "motorway-svg-fill",
  fillRule: "evenodd"
}));

export default MinusCircleSVG;
